import * as yup from 'yup'

const locationSchema = yup.object().shape({
  longitude: yup.string(),
  latitude: yup.string(),
  mapUrl: yup.string(),
  address: yup.string(),
})

/** Step 1 — About */
const eventAboutStepValidation = yup.object().shape({
  name: yup.string().required('Required *'),
  photo: yup.mixed(),
  photoInput: yup.mixed(),
  content: yup.mixed(),
  preWork: yup.mixed(),
  description: yup.string().required('Required *'),
  subHeading: yup.string().required('Required *'),
  audience: yup.string().required('Required *'),
})

/** Step 2 — Location & time */
const eventLocationStepValidation = yup.object().shape({
  startDate: yup.date().required().nullable(),
  endDate: yup.date().required().nullable(),
  type: yup.string().required('Required *'),
  webLink: yup.string().when('type', {
    is: 'online',
    then: (schema) => schema.required('Required *'),
    otherwise: (schema) => schema,
  }),
  separatedByDays: yup.boolean(),
  location: locationSchema,
})

/** @deprecated use eventAboutStepValidation */
const eventFirstStepValidation = yup.object().shape({
  name: yup.string().required('Required *'),
  photo: yup.mixed(),
  photoInput: yup.mixed(),
  content: yup.mixed(),
  preWork: yup.mixed(),
  description: yup.string().required('Required *'),
  subHeading: yup.string().required('Required *'),
  webLink: yup.string(),
  audience: yup.string().required('Required *'),
  type: yup.string(),
  startDate: yup.date().required().nullable(),
  endDate: yup.date().required().nullable(),
  location: locationSchema,
})

const agendaSchema = yup.object().shape({
  title: yup.string().required('Title is required'),
  startDate: yup.mixed().required('Date is required'),
  endDate: yup.mixed().required('Date is required'),
  // description: yup.string().required('Description is required'),
})
const speakerSchema = yup.object().shape({
  name: yup.string().required('Name is required'),
  designation: yup.string().required('Designation is required'),
  image: yup.mixed().required('Photo is required'),
  description: yup.string(),
})

/** Step 3 — Agenda */
const eventAgendaStepValidation = yup.object().shape({
  agenda: yup.array().of(agendaSchema).min(1, 'Please add at least one agenda'),
})

/** Step 4 — Speakers */
const eventSpeakerStepValidation = yup.object().shape({
  speakers: yup
    .array()
    .of(speakerSchema)
    .min(1, 'Please add at least one speaker'),
})

/** Step 5 — Gallery (optional) */
const eventGalleryStepValidation = yup.object().shape({
  gallery: yup.mixed(),
})

/** @deprecated combined step; use eventAgendaStepValidation + eventSpeakerStepValidation */
const eventSecondStepValidation = yup.object().shape({
  agenda: yup.array().of(agendaSchema).min(1, 'Please add at least one agenda'),
  speakers: yup
    .array()
    .of(speakerSchema)
    .min(1, 'Please add at least one speaker'),
})

const eventInitialValues = {
  name: '',
  photo: [],
  photoInput: '',
  ContentInput: '',
  preWorkInput: '',
  content: [],
  preWork: [],
  subHeading: '',
  description: '',
  startDate: null,
  endDate: null,
  separatedByDays: false,
  audience: '',
  type: '',
  inviteUserIds: [],
  webLink: '',
  location: {
    mapUrl: '',
    longitude: '',
    latitude: '',
    address: '',
  },
  agenda: [],
  speakers: [],
  galleryInput: '',
  gallery: [],
}
const agenda = {
  title: '',
  startDate: '',
  endDate: '',
  description: '',
}
const speaker = {
  name: '',
  designation: '',
  image: '',
  description: '',
}

const EVENT_TYPE = [
  {
    value: 'public',
    label: 'Public',
  },
  {
    value: 'private',
    label: 'Private',
  },
]

const EVENT_WIZARD_TOTAL_STEPS = 5

const EVENT_WIZARD_STEP_LABELS = [
  'About',
  'Location',
  'Agenda',
  'Speaker',
  'Gallery',
]

const EVENT_WIZARD_STEP_VALIDATION = {
  1: eventAboutStepValidation,
  2: eventLocationStepValidation,
  3: eventAgendaStepValidation,
  4: eventSpeakerStepValidation,
  5: eventGalleryStepValidation,
}

export {
  eventAboutStepValidation,
  eventLocationStepValidation,
  eventAgendaStepValidation,
  eventSpeakerStepValidation,
  eventGalleryStepValidation,
  eventFirstStepValidation,
  eventSecondStepValidation,
  eventInitialValues,
  agenda,
  EVENT_TYPE,
  EVENT_WIZARD_TOTAL_STEPS,
  EVENT_WIZARD_STEP_LABELS,
  EVENT_WIZARD_STEP_VALIDATION,
  agendaSchema,
  speakerSchema,
  speaker,
}
